import _ from 'lodash';
import { CLEAR_SITE_NOTIFICATIONS } from '@/store/mutation-types';

/**
 * Handle auth requests
 * @type {{request: bearerAuth.request, response: (function(*): CancelToken | Object.value | Token.value | string)}}
 */
const bearerAuth = {
  request(req, token) {
    // Every request that goes out passes the bearer token for an API to authenticate
    this.options.http._setHeaders.call(this, req, { Authorization: `Bearer ${token}` });
  },
  response(res) {
    // Attempt to parse the authorisation token from the API
    return (res.data || {}).token;
  },
};

/**
 * Generate auth options
 * @param opts
 * @returns {{parseUserData: (function(*): *), router: {_beforeEach: function(*, *=): void, _init: function(): (string|undefined), _routerGo: function(*=): void, _routerReplace: function(*=): void, _bindData: function(*=, *=): *}, fetchData: {url: string}, auth: {request: bearerAuth.request, response: ((function(*): CancelToken)|Object.value|Token.value|string)}, http: {_init: function(): (string|undefined), _setHeaders: function(*, *=): void, _http: function(*=): *, _getHeaders: function(*): *, _interceptor: function(*=, *=): void, _httpData: function(*): *, _invalidToken: function(*): (boolean|undefined)}, loginData: {fetchUser: boolean, url: string}, refreshData: {enabled: boolean}}}
 */
export function getAuthOptions(opts) {
  const { socket, store, localStorage } = opts;
  const apiEndpoint = process.env.VUE_APP_KOALABOSS_API;
  return {
    auth: bearerAuth,
    http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
    router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
    loginData: { url: `${apiEndpoint}/login-vue`, fetchUser: true },
    fetchData: { url: `${apiEndpoint}/api/auth/user` },
    refreshData: { enabled: false },
    parseUserData(data) {
      store.commit(CLEAR_SITE_NOTIFICATIONS);
      store.commit('setAppData', data.data);
      store.commit('setDarkMode', _.get(data.data, 'user.preferences.darkMode'));
      store.commit('setSidebarMinimize', _.get(data.data, 'user.preferences.sidebarMinimize'));
      store.commit('setAsideShow', _.get(data.data, 'user.preferences.asideShow'));
      store.commit('setViewMode', _.get(data.data, 'user.preferences.viewMode'));
      socket.emit('room', data.data.user.organisationId);
      socket.on('siteUpdateNotification', (data) => {
        store.commit('SOCKET_SITEUPDATENOTIFICATION', data);
      });
      socket.on('siteBackupNotification', (data) => {
        store.commit('SOCKET_BACKUPUPDATENOTIFICATION', data);
      });
      socket.on('siteThemeUpdateNotification', (data) => {
        store.commit('SOCKET_SITETHEMEUPDATENOTIFICATION', data);
      });
      socket.on('pluginUpdateNotification', (data) => {
        store.commit('SOCKET_PLUGINUPDATENOTIFICATION', data);
      });
      localStorage.set('mp-sid', data.data.user.organisationId);
      return data.data;
    },
  };
}
